import {
  getNewCandidates,
  getKeepInViewCandidates,
  getAdmittedCandidates,
  getDeclinedCandidates,
} from 'redux/applicants/saga/fetchCandidates';
import { onChangeApplicantStage } from 'redux/applicants/saga/changeApplicantStage';
import { getApplications, onSearchApplication } from 'redux/applicants/saga/fetchApplications';
import { getApplicantForm } from 'redux/applicants/saga/fetchApplicantForm';
import { getFormSchema } from 'redux/applicants/saga/fetchFormSchema';
import { onNotifyApplicants } from 'redux/applicants/saga/notifyApplicants';
import { onExportData } from 'redux/applicants/saga/exportApplicantData';
import { call, all } from 'redux-saga/effects';
import { onBatchProcess } from './batchProcessApplicants';
import { onEmailSend } from './sendEmailToApplicant';
import { getPreloadedStats } from './fetchPreloadedCandidateStats';
import { getApplicantEmails } from './fetchApplicantEmails';
import { getApplicantTransactions } from './fetchApplicantTransactions';

export default function* formsSaga() {
  yield all([
    call(getNewCandidates),
    call(onChangeApplicantStage),
    call(getKeepInViewCandidates),
    call(getAdmittedCandidates),
    call(getDeclinedCandidates),
    call(getApplications),
    call(onSearchApplication),
    call(getApplicantForm),
    call(getFormSchema),
    call(onNotifyApplicants),
    call(onExportData),
    call(onBatchProcess),
    call(onEmailSend),
    call(getPreloadedStats),
    call(getApplicantEmails),
    call(getApplicantTransactions)
  ]);
}
